import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImagilityBaseResponse } from 'app-models';
import { map, pluck } from 'rxjs/operators';
import { EncryptService } from '../../core/http/http-encrypt.service';

@Injectable({
  providedIn: 'root'
})
export class FdButtonFormCreationService {

  constructor(private http: HttpClient, private encryptService: EncryptService) { }

  onSaveCreateFormJson(payload) {
    return this.http.post(`/vd/formBuilder/createFormDetails`, payload).pipe(
      map((response: ImagilityBaseResponse) => {
        if (response.status === 200) {
          return response;
        }
        else {
          return null;
        }
      })
    );
  }

  getPageFormDetailsByButtonId(pageFormButtonId) {
    // return this.http.get(`/vd/formBuilder/${pageBuilderId}/createdPage`).pipe(
    return this.http.get(`/vd/formBuilder/buttonId/${pageFormButtonId}/pageFormDetails`).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }

  getPageFormsListByModuleId(moduleId) {
    // return this.http.get(`/vd/formBuilder/${pageBuilderId}/createdPage`).pipe(
    return this.http.get(`/vd/formBuilder/createForms/module/${moduleId}/list`).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }

  getUniqueName(pageFormId, getUniqueName) {
    // return this.http.get(`/vd/formBuilder/${pageBuilderId}/createdPage`).pipe(
    return this.http.get(`/vd/formBuilder/pageFormId/${pageFormId}/formUniqueName/${getUniqueName}/exists`).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }

  getRoles(moduleId) {
    return this.http.get(`/module/${moduleId}/role`).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }
  
  getPageFormsByButton() {
    return this.http.get(`/vd/formBuilder/createForms/byButton/list`).pipe(
      pluck('data'), map((data: Array<any>) => {
        return data;
      })
    );
  }

  getFormsListByModuleId(groupName, moduleId) {
    //let encryptedText = this.encryptService.toEncrypt(groupName);
    return this.http.get(`/vd/dataSource/${groupName}/elements?id=${moduleId}`).pipe(
      pluck('data'), map((data: Array<any>) => {  
        return data;
      })
    );
  }
}
